import type {
	ButtonSplitRouteAvailabilityOptions,
	ButtonSplitRouteAvailabilityResolver,
} from './buttonSplitRouting.model';

const defaultResolver: ButtonSplitRouteAvailabilityResolver = () => false;

let splitRouteAvailabilityResolver = defaultResolver;

export const setButtonSplitRouteAvailabilityResolver = (
	resolver?: ButtonSplitRouteAvailabilityResolver
): void => {
	splitRouteAvailabilityResolver = resolver || defaultResolver;
};

export const isButtonSplitRouteAvailable = (
	options: ButtonSplitRouteAvailabilityOptions = {}
): boolean => {
	return splitRouteAvailabilityResolver(options);
};
